import request from "../../Frontends/Common/utils/request/requestMain";
const _ = require("lodash");
const rootRoute = "/addressprogramarchived/externalformat/";

export default class ExternalFormatApi {
  constructor() {
    this.defaultModel = {
    };
  }
  async getExternalFormats(params) {
    return await request.post(`${rootRoute}getExternalFormats`, {
      filter: params,
      parameters: {},
    });
  }
  async getExternalFormat(id) {
    return await request.post(`${rootRoute}getExternalFormats`, {
      filter: `$filter=Id eq ${id}`,
      parameters: {},
    });
  }
  async createExternalFormat(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}createExternalFormat`, { data });
  }
  async deleteExternalFormat(model) {
    const data = [model];
    return await request.post(`${rootRoute}deleteExternalFormat`, { data });
  }
  async editExternalFormat(model) {
    const data = [_.merge(_.cloneDeep(this.defaultModel), model)];
    return await request.post(`${rootRoute}updateExternalFormat`, { data });
  }
  async import(gfid) {
    return await request.post(`${rootRoute}importExternalFormat`, {
      gfid: gfid
    });
  }
  async getImportScaffold() {
    return await request.post(`${rootRoute}getExternalFormatimporttemplate`, null, {responseType: 'blob'});
  }
  async export(filter, format) {
    return await request.post(`${rootRoute}exportExternalFormat`, {
      filter: filter,
      format: format
    });
  }
}
